module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185813.d76d89a4.jpg";